import dayjs from 'dayjs';
import type { ImportFileParseResult } from './aisImport.ts';

export const normalizeImportResult = (result: ImportFileParseResult): ImportFileParseResult => {
  if (dayjs(result.patientData.birthday).isSame(dayjs('9999-01-01'))) {
    // bad hack
    result.patientData.birthday = '';
  }
  if (result.patientData.insuredPerson && dayjs(result.patientData.insuredPerson.birthday).isSame(dayjs('9999-01-01'))) {
    // bad hack
    result.patientData.insuredPerson.birthday = '';
  }
  if (result.invalidPatientFields.includes('P-Geschlecht')) {
    // bad hack
    // biome-ignore lint/suspicious/noExplicitAny: null cast for invalid gender field
    result.patientData.gender = null as any;
  }
  return result;
};
